import React, { useState, useEffect } from 'react';
import styles from './ListasModal.module.css';
import Button from '../ui/button';
import Input from '../ui/input';
import Dropdown from '../ui/dropdown';
import { showErrorToast, showSuccessToast } from '../../utils/notifications';
import { MyIcons } from '../icons/my-icons';
import {
  // APIs de listas
  getListaExpedientes,
  getListaFechaParte,
  getListaResumenPagoOperario,
  getListaCosteReparadores,
  getListaMargenBruto,
  getListaFacturasPendienteCobro,
  getListaRatioFacturasPendienteCobro,
  getListaFacturasCobradas,
  getListaResumenFacturacionAnual,
  getListaFacturacionMensual,
  getListaFacturacionIva,
  getListaFacturacion,
  getListaPrefacturas,
  getListado347,
  getListaHonorariosComerciales,
  getListaCosteSinFactura,
  // APIs auxiliares
  getCommercials,
  getCompanies,
  getCompaniesByCommercial,
  getWorkers,
  getStates,
  getJobTypes,
} from '../../services/apiService';

// Configuración de cada tipo de lista (fuera del componente para evitar re-creación)
const listConfigs = {
  // Listados Gestión
  'expedientes': {
    title: 'Expedientes',
    filters: ['comerciales', 'companias', 'estados', 'tipoTrabajo', 'fechaDesde', 'fechaHasta'],
    requiredFields: [],
    apiCall: getListaExpedientes,
    filename: 'listado_expedientes.xlsx'
  },
  'fechaParte': {
    title: 'Fecha Parte Operarios',
    filters: ['operarios'],
    requiredFields: [],
    apiCall: getListaFechaParte,
    filename: 'listado_fecha_parte.xlsx'
  },
  // Listados Técnicos
  'resumenPagoOperario': {
    title: 'Resumen Pagos por Operario',
    filters: ['operarios', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaResumenPagoOperario,
    filename: 'listado_resumen_pago_operario.xlsx'
  },
  'costeReparadores': {
    title: 'Listado Coste Reparadores',
    filters: ['fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaCosteReparadores,
    filename: 'listado_coste_reparadores.xlsx'
  },
  // Listados Administración
  'margenBruto': {
    title: 'Margen Bruto',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaMargenBruto,
    filename: 'listado_margen_bruto.xlsx'
  },
  'facturasPendienteCobro': {
    title: 'Facturas Pendiente de Cobro',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: [],
    apiCall: getListaFacturasPendienteCobro,
    filename: 'listado_facturas_pendiente_cobro.xlsx'
  },
  'ratioFacturasPendienteCobro': {
    title: 'Ratio Facturas Pendientes de Cobro',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaRatioFacturasPendienteCobro,
    filename: 'listado_ratio_facturas_pendiente_cobro.xlsx'
  },
  'facturasCobradas': {
    title: 'Facturas Cobradas',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaFacturasCobradas,
    filename: 'listado_facturas_cobradas.xlsx'
  },
  'resumenFacturacionAnual': {
    title: 'Resumen Facturación Anual Compañías',
    filters: ['comerciales', 'companias', 'ano', 'tipoCompania'],
    requiredFields: ['ano'],
    apiCall: getListaResumenFacturacionAnual,
    filename: 'listado_resumen_facturacion_anual.xlsx'
  },
  'facturacionMensual': {
    title: 'Facturación Mensual',
    filters: ['ano'],
    requiredFields: ['ano'],
    apiCall: getListaFacturacionMensual,
    filename: 'listado_facturacion_mensual.xlsx'
  },
  'facturacionIva': {
    title: 'Listado de Facturas por IVA',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaFacturacionIva,
    filename: 'listado_facturacion_iva.xlsx'
  },
  'facturacion': {
    title: 'Listado de Facturas',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta', 'nif'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaFacturacion,
    filename: 'listado_facturas.xlsx'
  },
  'prefacturas': {
    title: 'Listado de Pre-facturas',
    filters: ['comerciales', 'companias', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaPrefacturas,
    filename: 'listado_prefacturas.xlsx'
  },
  'listado347': {
    title: 'Listado 347',
    filters: ['comerciales', 'companias', 'ano'],
    requiredFields: ['ano'],
    apiCall: getListado347,
    filename: 'listado_347.xlsx'
  },
  'honorariosComerciales': {
    title: 'Honorarios Comerciales',
    filters: ['comerciales', 'fechaDesde', 'fechaHasta'],
    requiredFields: ['fechaDesde', 'fechaHasta'],
    apiCall: getListaHonorariosComerciales,
    filename: 'listado_honorarios_comerciales.xlsx'
  },
  'costeSinFactura': {
    title: 'Expedientes con Coste y Sin Factura',
    filters: ['fechaDesde', 'fechaHasta'],
    requiredFields: [],
    apiCall: getListaCosteSinFactura,
    filename: 'listado_coste_sin_factura.xlsx'
  },
};

/**
 * Modal genérico para todas las listas
 * Props:
 * - isOpen: boolean (si el modal está visible)
 * - onClose: función para cerrar el modal
 * - listType: string que identifica el tipo de lista a generar
 */
export default function ListasModal({ 
  isOpen, 
  onClose,
  listType
}) {
  const [loading, setLoading] = useState(false);

  // Filtros comunes
  const [comerciales, setComerciales] = useState([]);
  const [comercialesSeleccionados, setComercialesSeleccionados] = useState([]);
  
  const [companias, setCompanias] = useState([]);
  const [companiasSeleccionadas, setCompaniasSeleccionadas] = useState([]);
  
  const [operarios, setOperarios] = useState([]);
  const [operariosSeleccionados, setOperariosSeleccionados] = useState([]);
  
  const [estados, setEstados] = useState([]);
  const [estadosSeleccionados, setEstadosSeleccionados] = useState([]);
  
  const [tipoTrabajos, setTipoTrabajos] = useState([]);
  const [tipoTrabajosSeleccionados, setTipoTrabajosSeleccionados] = useState([]);
  
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [fecha, setFecha] = useState('');
  const [ano, setAno] = useState('');
  const [nif, setNif] = useState('');
  
  const [tipoCompaniaSelected, setTipoCompaniaSelected] = useState(null);
  const [tipoCompanias, setTipoCompanias] = useState([]);

  // Obtener la configuración del tipo de lista actual
  const currentConfig = listConfigs[listType];

  // Cargar datos iniciales
  useEffect(() => {
    if (!isOpen || !currentConfig) return;

    let isMounted = true;

    const loadInitialData = async () => {
      try {
        // Cargar comerciales si se necesitan
        if (currentConfig.filters.includes('comerciales')) {
          const comercialesData = await getCommercials();
          if (!isMounted) return;
          const formattedComerciales = [
            { value: 'all', label: 'Todos' },
            ...comercialesData.map(c => ({ value: c.id, label: c.nombre }))
          ];
          setComerciales(formattedComerciales);
          // Preseleccionar "Todos"
          setComercialesSeleccionados([{ value: 'all', label: 'Todos' }]);
          
          // Si hay filtro de compañías junto con comerciales, cargar todas las compañías al inicio
          if (currentConfig.filters.includes('companias')) {
            const companiasData = await getCompanies();
            if (!isMounted) return;
            const formattedCompanias = [
              { value: 'all', label: 'Todas' },
              ...companiasData.map(c => ({ value: c.id, label: c.nombre }))
            ];
            setCompanias(formattedCompanias);
            // Preseleccionar "Todas"
            setCompaniasSeleccionadas([{ value: 'all', label: 'Todas' }]);
          }
        }

        // Cargar compañías solo si NO hay filtro de comerciales
        if (currentConfig.filters.includes('companias') && !currentConfig.filters.includes('comerciales')) {
          const companiasData = await getCompanies();
          if (!isMounted) return;
          const formattedCompanias = [
            { value: 'all', label: 'Todas' },
            ...companiasData.map(c => ({ value: c.id, label: c.nombre }))
          ];
          setCompanias(formattedCompanias);
          // Preseleccionar "Todas"
          setCompaniasSeleccionadas([{ value: 'all', label: 'Todas' }]);
        }

        // Cargar operarios si se necesitan
        if (currentConfig.filters.includes('operarios')) {
          const operariosData = await getWorkers();
          if (!isMounted) return;
          const formattedOperarios = [
            { value: 'all', label: 'Todos' },
            ...operariosData.map(o => ({ value: o.id, label: o.nombre }))
          ];
          setOperarios(formattedOperarios);
          // Preseleccionar "Todos"
          setOperariosSeleccionados([{ value: 'all', label: 'Todos' }]);
        }

        // Cargar estados si se necesitan
        if (currentConfig.filters.includes('estados')) {
          const estadosData = await getStates();
          if (!isMounted) return;
          const formattedEstados = [
            { value: 'all', label: 'Todos' },
            ...estadosData.map(e => ({ value: e.codigo, label: e.nombre }))
          ];
          setEstados(formattedEstados);
          // Preseleccionar "Todos"
          setEstadosSeleccionados([{ value: 'all', label: 'Todos' }]);
        }

        // Cargar tipos de trabajo si se necesitan
        if (currentConfig.filters.includes('tipoTrabajo')) {
          const tipoTrabajosData = await getJobTypes();
          if (!isMounted) return;
          const formattedTipoTrabajos = [
            { value: 'all', label: 'Todos' },
            ...tipoTrabajosData.map(t => ({ value: t.id, label: t.nombre }))
          ];
          setTipoTrabajos(formattedTipoTrabajos);
          // Preseleccionar "Todos"
          setTipoTrabajosSeleccionados([{ value: 'all', label: 'Todos' }]);
        }

        // Configurar tipos de compañía si se necesitan
        if (currentConfig.filters.includes('tipoCompania')) {
          const tiposCompania = [
            { value: 'all', label: 'Todos' },
            { value: 'S', label: 'S' },
            { value: 'A', label: 'A' },
            { value: 'B', label: 'B' },
            { value: 'C', label: 'C' }
          ];
          if (!isMounted) return;
          setTipoCompanias(tiposCompania);
          setTipoCompaniaSelected({ value: 'all', label: 'Todos' });
        }
      } catch (error) {
        console.error('Error loading initial data:', error);
        // No mostrar toast de error para evitar spam, solo log en consola
      }
    };

    if (isOpen && currentConfig) {
      loadInitialData();
    }

    return () => {
      isMounted = false;
    };
  }, [isOpen, listType, currentConfig]);

  const handleClose = () => {
    // Reset todos los filtros
    setComerciales([]);
    setComercialesSeleccionados([]);
    setCompanias([]);
    setCompaniasSeleccionadas([]);
    setOperarios([]);
    setOperariosSeleccionados([]);
    setEstados([]);
    setEstadosSeleccionados([]);
    setTipoTrabajos([]);
    setTipoTrabajosSeleccionados([]);
    setFechaDesde('');
    setFechaHasta('');
    setFecha('');
    setAno('');
    setNif('');
    setTipoCompaniaSelected(null);
    setTipoCompanias([]);
    onClose();
  };

  const handleDownload = async (e) => {
    e.preventDefault();

    if (!currentConfig) {
      showErrorToast('Configuración de lista no encontrada');
      return;
    }

    // Validar campos requeridos
    for (const field of currentConfig.requiredFields) {
      if (field === 'fechaDesde' && !fechaDesde) {
        showErrorToast('La fecha desde es obligatoria');
        return;
      }
      if (field === 'fechaHasta' && !fechaHasta) {
        showErrorToast('La fecha hasta es obligatoria');
        return;
      }
      if (field === 'fecha' && !fecha) {
        showErrorToast('La fecha es obligatoria');
        return;
      }
      if (field === 'ano' && !ano) {
        showErrorToast('El año es obligatorio');
        return;
      }
    }

    try {
      setLoading(true);

      // Preparar parámetros según el tipo de lista
      let params = [];

      switch (listType) {
        case 'expedientes':
          params = [
            companiasSeleccionadas.length > 0 ? companiasSeleccionadas.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            fechaDesde,
            fechaHasta,
            estadosSeleccionados.length > 0 ? estadosSeleccionados.filter(e => e.value !== 'all').map(e => e.value).join(',') : '',
            tipoTrabajosSeleccionados.length > 0 ? tipoTrabajosSeleccionados.filter(t => t.value !== 'all').map(t => t.value).join(',') : ''
          ];
          break;
        
        case 'fechaParte':
          params = [
            operariosSeleccionados.length > 0 ? operariosSeleccionados.filter(o => o.value !== 'all').map(o => o.value).join(',') : ''
          ];
          break;
        
        case 'resumenPagoOperario':
          params = [
            operariosSeleccionados.length > 0 ? operariosSeleccionados.filter(o => o.value !== 'all').map(o => o.value).join(',') : '',
            fechaDesde,
            fechaHasta
          ];
          break;
        
        case 'costeReparadores':
          params = [fechaDesde, fechaHasta];
          break;
        
        case 'margenBruto':
        case 'facturasPendienteCobro':
        case 'ratioFacturasPendienteCobro':
        case 'facturasCobradas':
        case 'facturacionIva':
        case 'prefacturas':
          params = [
            companiasSeleccionadas.length > 0 ? companiasSeleccionadas.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            fechaDesde,
            fechaHasta
          ];
          break;
        
        case 'resumenFacturacionAnual':
          params = [
            companiasSeleccionadas.length > 0 ? companiasSeleccionadas.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            ano,
            tipoCompaniaSelected && tipoCompaniaSelected.value !== 'all' ? tipoCompaniaSelected.value : ''
          ];
          break;
        
        case 'facturacionMensual':
          params = [ano];
          break;
        
        case 'facturacion':
          params = [
            companiasSeleccionadas.length > 0 ? companiasSeleccionadas.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            fechaDesde,
            fechaHasta,
            nif
          ];
          break;
        
        case 'listado347':
          params = [
            companiasSeleccionadas.length > 0 ? companiasSeleccionadas.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            ano
          ];
          break;
        
        case 'honorariosComerciales':
          params = [
            comercialesSeleccionados.length > 0 ? comercialesSeleccionados.filter(c => c.value !== 'all').map(c => c.value).join(',') : '',
            fechaDesde,
            fechaHasta
          ];
          break;

        case 'costeSinFactura':
          params = [fechaDesde, fechaHasta];
          break;
        
        default:
          showErrorToast('Tipo de lista no implementado');
          return;
      }

      // Llamar a la API
      const blob = await currentConfig.apiCall(...params);

      // Descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = currentConfig.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showSuccessToast('Listado descargado correctamente');
      handleClose();
    } catch (error) {
      console.error('Error downloading list:', error);
      showErrorToast(error.message || 'Error al descargar el listado');
    } finally {
      setLoading(false);
    }
  };

  // Handlers para multiselect
  const handleComercialSelect = async (options) => {
    console.log('=== handleComercialSelect iniciado ===');
    console.log('Comerciales seleccionados:', options);
    console.log('currentConfig existe?:', !!currentConfig);
    console.log('Tiene filtro de companias?:', currentConfig?.filters.includes('companias'));
    
    if (!options || !Array.isArray(options)) {
      setComercialesSeleccionados([]);
      // Si no hay comerciales seleccionados, cargar todas las compañías
      if (currentConfig?.filters.includes('companias')) {
        try {
          const companiasData = await getCompanies();
          const formattedCompanias = [
            { value: 'all', label: 'Todas' },
            ...companiasData.map(c => ({ value: c.id, label: c.nombre }))
          ];
          setCompanias(formattedCompanias);
          setCompaniasSeleccionadas([{ value: 'all', label: 'Todas' }]);
        } catch (error) {
          console.error('Error loading all companies:', error);
        }
      }
      return;
    }
    setComercialesSeleccionados(options);
    
    // Si hay comerciales seleccionados y el filtro de compañías está activo
    if (currentConfig?.filters.includes('companias')) {
      try {
        // Filtrar los comerciales válidos (excluir 'all')
        const validComerciales = options.filter(c => c.value !== 'all');
        console.log('Comerciales válidos (sin "Todos"):', validComerciales);
        
        // Si se selecciona "Todos" o no hay comerciales específicos, cargar todas las compañías
        const hasTodos = options.some(c => c.value === 'all');
        
        if (options.length === 0 || validComerciales.length === 0 || hasTodos) {
          // Cargar todas las compañías
          console.log('Cargando todas las compañías');
          const companiasData = await getCompanies();
          const formattedCompanias = [
            { value: 'all', label: 'Todas' },
            ...companiasData.map(c => ({ value: c.id, label: c.nombre }))
          ];
          setCompanias(formattedCompanias);
          // Preseleccionar "Todas"
          setCompaniasSeleccionadas([{ value: 'all', label: 'Todas' }]);
        } else {
          // Obtener las compañías de los comerciales seleccionados
          const comercialesIds = validComerciales.map(c => c.value).join(',');
          console.log('Obteniendo compañías para comerciales:', comercialesIds);
          const companiasData = await getCompaniesByCommercial(comercialesIds);
          console.log('Compañías obtenidas de la API:', companiasData);
          console.log('Tipo de companiasData:', Array.isArray(companiasData) ? 'Array' : typeof companiasData);
          console.log('Longitud de companiasData:', companiasData?.length);
          
          const formattedCompanias = [
            { value: 'all', label: 'Todas' },
            ...companiasData.map(c => ({ value: c.id, label: c.nombre }))
          ];
          console.log('Compañías formateadas para dropdown:', formattedCompanias);
          console.log('Longitud de formattedCompanias:', formattedCompanias.length);
          
          console.log('Llamando setCompanias con:', formattedCompanias);
          setCompanias(formattedCompanias);
          console.log('setCompanias ejecutado');
          
          // Verificar inmediatamente después (aunque esto puede no reflejar el cambio aún por ser async)
          setTimeout(() => {
            console.log('Estado de companias después de 100ms:', companias);
          }, 100);
          
          // Limpiar las compañías seleccionadas que ya no están disponibles
          setCompaniasSeleccionadas(prev => {
            const filtered = prev.filter(comp => 
              comp.value === 'all' || 
              companiasData.some(c => c.id === comp.value)
            );
            console.log('Compañías seleccionadas después del filtro:', filtered);
            return filtered;
          });
        }
      } catch (error) {
        console.error('Error loading companies by commercial:', error);
        showErrorToast('Error al cargar las compañías del comercial');
      }
    }
  };

  const handleCompaniaSelect = (options) => {
    if (!options || !Array.isArray(options)) {
      setCompaniasSeleccionadas([]);
      return;
    }
    setCompaniasSeleccionadas(options);
  };

  const handleOperarioSelect = (options) => {
    if (!options || !Array.isArray(options)) {
      setOperariosSeleccionados([]);
      return;
    }
    setOperariosSeleccionados(options);
  };

  const handleEstadoSelect = (options) => {
    if (!options || !Array.isArray(options)) {
      setEstadosSeleccionados([]);
      return;
    }
    setEstadosSeleccionados(options);
  };

  const handleTipoTrabajoSelect = (options) => {
    if (!options || !Array.isArray(options)) {
      setTipoTrabajosSeleccionados([]);
      return;
    }
    setTipoTrabajosSeleccionados(options);
  };

  if (!isOpen || !currentConfig) return null;

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{currentConfig.title}</h2>
          <button
            className={styles.closeButton}
            onClick={handleClose}
            type="button"
          >
            <MyIcons name="close" width={20} height={20} color="var(--gray)" />
          </button>
        </div>

        <form onSubmit={handleDownload} className={styles.form}>
          {/* Comerciales */}
          {currentConfig.filters.includes('comerciales') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>Comerciales</label>
              <Dropdown
                options={comerciales}
                selected={comercialesSeleccionados}
                onSelect={handleComercialSelect}
                placeholder="Selecciona comerciales"
                multiSelect={true}
                disabled={loading}
              />
            </div>
          )}

          {/* Compañías y Estados en la misma fila */}
          {(currentConfig.filters.includes('companias') || currentConfig.filters.includes('estados')) && (
            <div className={styles.formRow}>
              {currentConfig.filters.includes('companias') && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>Compañías</label>
                  <Dropdown
                    options={companias}
                    selected={companiasSeleccionadas}
                    onSelect={handleCompaniaSelect}
                    placeholder="Selecciona compañías"
                    multiSelect={true}
                    disabled={loading}
                  />
                </div>
              )}

              {currentConfig.filters.includes('estados') && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>Estados</label>
                  <Dropdown
                    options={estados}
                    selected={estadosSeleccionados}
                    onSelect={handleEstadoSelect}
                    placeholder="Selecciona estados"
                    multiSelect={true}
                    disabled={loading}
                  />
                </div>
              )}
            </div>
          )}

          {/* Tipo Trabajo en su propia fila */}
          {currentConfig.filters.includes('tipoTrabajo') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>Tipo Trabajo</label>
              <Dropdown
                options={tipoTrabajos}
                selected={tipoTrabajosSeleccionados}
                onSelect={handleTipoTrabajoSelect}
                placeholder="Selecciona tipo de trabajo"
                multiSelect={true}
                disabled={loading}
              />
            </div>
          )}

          {/* Operarios */}
          {currentConfig.filters.includes('operarios') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>Operarios</label>
              <Dropdown
                options={operarios}
                selected={operariosSeleccionados}
                onSelect={handleOperarioSelect}
                placeholder="Selecciona operarios"
                multiSelect={true}
                disabled={loading}
              />
            </div>
          )}

          {/* Fecha Desde y Fecha Hasta en la misma fila */}
          {(currentConfig.filters.includes('fechaDesde') || currentConfig.filters.includes('fechaHasta')) && (
            <div className={styles.formRow}>
              {currentConfig.filters.includes('fechaDesde') && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>
                    Fecha Desde {currentConfig.requiredFields.includes('fechaDesde') && <span className={styles.required}>*</span>}
                  </label>
                  <Input
                    type="date"
                    value={fechaDesde}
                    onChange={(e) => setFechaDesde(e.target.value)}
                    disabled={loading}
                    required={currentConfig.requiredFields.includes('fechaDesde')}
                  />
                </div>
              )}

              {currentConfig.filters.includes('fechaHasta') && (
                <div className={styles.formGroup}>
                  <label className={styles.label}>
                    Fecha Hasta {currentConfig.requiredFields.includes('fechaHasta') && <span className={styles.required}>*</span>}
                  </label>
                  <Input
                    type="date"
                    value={fechaHasta}
                    onChange={(e) => setFechaHasta(e.target.value)}
                    disabled={loading}
                    required={currentConfig.requiredFields.includes('fechaHasta')}
                  />
                </div>
              )}
            </div>
          )}

          {/* Fecha (single) */}
          {currentConfig.filters.includes('fecha') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>
                Fecha {currentConfig.requiredFields.includes('fecha') && <span className={styles.required}>*</span>}
              </label>
              <Input
                type="date"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                disabled={loading}
                required={currentConfig.requiredFields.includes('fecha')}
              />
            </div>
          )}

          {/* Año */}
          {currentConfig.filters.includes('ano') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>
                Año {currentConfig.requiredFields.includes('ano') && <span className={styles.required}>*</span>}
              </label>
              <Input
                type="text"
                value={ano}
                onChange={(e) => setAno(e.target.value)}
                placeholder="2025"
                disabled={loading}
                required={currentConfig.requiredFields.includes('ano')}
              />
            </div>
          )}

          {/* NIF */}
          {currentConfig.filters.includes('nif') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>NIF</label>
              <Input
                type="text"
                value={nif}
                onChange={(e) => setNif(e.target.value)}
                placeholder="NIF de la compañía"
                disabled={loading}
              />
            </div>
          )}

          {/* Tipo Compañía */}
          {currentConfig.filters.includes('tipoCompania') && (
            <div className={styles.formGroup}>
              <label className={styles.label}>Tipo Compañía</label>
              <Dropdown
                options={tipoCompanias}
                selected={tipoCompaniaSelected}
                onSelect={setTipoCompaniaSelected}
                placeholder="Selecciona tipo"
                disabled={loading}
              />
            </div>
          )}

          <div className={styles.buttonGroup}>
            <Button
              type="button"
              variant="secondary"
              onClick={handleClose}
              disabled={loading}
            >
              CANCELAR
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'DESCARGANDO...' : 'DESCARGAR'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
